export const productKeys = {
  all: ['products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...productKeys.lists(), filters] as const,
  details: () => [...productKeys.all, 'detail'] as const,
  detail: (handle: string) => [...productKeys.details(), handle] as const,
}

export const cartKeys = {
  all: ['cart'] as const,
  detail: (cartId: string) => [...cartKeys.all, cartId] as const,
  summary: (cartId: string) => [...cartKeys.all, 'summary', cartId] as const,
  // Fallback key used before the client cart id is known (fresh load /
  // second tab). Distinct leaf so it never collides with a detail key.
  pending: () => [...cartKeys.all, '__pending__'] as const,
}

export const fullDetailsKeys = {
  all: ['full-details'] as const,
  detail: (productId: string) => [...fullDetailsKeys.all, productId] as const,
}

export const rentalKeys = {
  all: ['rental'] as const,
  info: (productId: string) => [...rentalKeys.all, 'info', productId] as const,
  availability: (productId: string, startDate?: string, period?: number) =>
    [...rentalKeys.all, 'availability', productId, { startDate, period }] as const,
  list: (filters?: Record<string, unknown>) => [...rentalKeys.all, 'list', filters] as const,
  detail: (rentalId: string) => [...rentalKeys.all, 'detail', rentalId] as const,
}

export const filterKeys = {
  all: ['filters'] as const,
  initial: (locale: string) => [...filterKeys.all, 'initial', locale] as const,
  facets: (params: Record<string, string>) => [...filterKeys.all, 'facets', params] as const,
}

export const customerKeys = {
  all: ['customer'] as const,
  me: () => [...customerKeys.all, 'me'] as const,
  addresses: () => [...customerKeys.all, 'addresses'] as const,
  orders: (filters?: Record<string, unknown>) => [...customerKeys.all, 'orders', filters] as const,
}

export const shippingKeys = {
  all: ['shipping'] as const,
  options: (cartId: string) => [...shippingKeys.all, 'options', cartId] as const,
  /** «Прислать или заберу сам» — считается по живым остаткам, не по строке. */
  modes: (cartId: string) => [...shippingKeys.all, 'modes', cartId] as const,
}

export const paymentKeys = {
  all: ['payment'] as const,
  providers: (regionId: string) => [...paymentKeys.all, 'providers', regionId] as const,
}
